var path = '/home/travis/build/orizens/echoes/src/core/components/youtube-components/youtube-list/youtube-list.tpl.html';
var html = "<ul class=\"list-unstyled clearfix\"><li class=\"pull-left youtube-list-item\" ng-repeat=\"video in vm.videos track by $index\"><youtube-media video=video on-play=vm.playSelectedVideo(video) on-queue=vm.queueSelectedVideo(video) on-add=vm.add(video)></youtube-media></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/core/components/youtube-components/youtube-list/youtube-list.tpl.html
 ** module id = 140
 ** module chunks = 1
 **/